// src/modules/materials/components/ServiceTable.js
// Hizmet tablosu bileşeni

import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, IconButton, Typography, Checkbox
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const ServiceTable = ({ services, selectedIds, onToggle }) => {
    return (
        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Hizmet Adı</TableCell>
                        <TableCell>Açıklama</TableCell>
                        <TableCell align="right">Fiyat</TableCell>
                        <TableCell align="center">İşlem</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {services.map((service) => (
                        <TableRow
                            key={service.id}
                            hover
                            selected={selectedIds.has(service.id)}
                        >
                            <TableCell>{service.hizmetAdi}</TableCell>
                            <TableCell>{service.aciklama || '-'}</TableCell>
                            <TableCell align="right">
                                {Number(service.fiyat).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                            </TableCell>
                            <TableCell align="center">
                                <Checkbox
                                    checked={selectedIds.has(service.id)}
                                    onChange={() => onToggle(service)}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                    {services.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                <Typography color="text.secondary">Hizmet bulunamadı</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ServiceTable;
